module.exports = __webpack_public_path__ + "static/media/logo_white.9006c11e.svg";